export default __webpack_public_path__ + "static/156-min-min-5d0ee29a421067fa475970ffb4515ed6.jpg";